import { useEffect as t } from "react";
const a = ({ enabled: e }) => {
  t(() => {
    const o = (n) => {
      if (e) {
        const r = "You have unsaved changes. Are you sure you want to leave?";
        return n.preventDefault(), n.returnValue = r, r;
      }
    };
    return window.addEventListener("beforeunload", o), () => {
      window.removeEventListener("beforeunload", o);
    };
  }, [e]);
};
export {
  a as u
};
